// extracted by mini-css-extract-plugin
module.exports = {"input":"input--074bb"};